<template>
  <div
    class="d-flex px-2 align-items-center justify-content-center banner-header mb-3 "
    v-if="
      content &&
        content.settings &&
        content.settings.general &&
        content.settings.general.title_banner_header
    "
  >
    <h4 class="m-0">
      {{ content.settings.general.title_banner_header }}
    </h4>
  </div>
</template>
<script>
export default {
  computed: {
    content() {
      return this.$store.getters["front/getHomeData"];
    },
  },
};
</script>
<style scoped>
.banner-header {
  background-color: var(--newTheme-color);
  color: #fff;
  padding-block: 10px;
}

.banner-header h4 {
  font-size: 16px;
  padding-block: 6px;
  line-height: 1.5;
}

@media screen and (max-width: 600px) {
  .banner-header h4 {
    font-size: 14px;
    text-align: center;
  }

  .banner-header {
    background-color: var(--newTheme-color);
    color: #fff;
    padding-block: 12px;
  }
}
</style>
